import styled, { css } from 'styled-components';

import { RadiusConfig, Row, neutral } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

export const InputPhoneContainer = styled(Row)<{ is_disabled: boolean }>`
  ${({ is_disabled }) => {
    const bg = is_disabled ? neutral['neutral-3'] : '#ffffff';
    const color = is_disabled ? neutral['neutral-5'] : neutral['neutral-10'];

    return css`
      .PhoneInput {
        padding: 0px 10px;
        border-radius: ${RadiusConfig.xs}px;
        border: 1px solid #00000026;
        height: 44px;
        background-color: ${bg};
        width: 100%;
      }
      .PhoneInputInput {
        outline: none;
        border: none;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: ${color};
        background: transparent;
      }

      .PhoneInputCountrySelect {
        display: none;
      }

      .PhoneInputCountrySelectArrow {
        display: none;
      }
    `;
  }}
`;

export const InvalidPhoneMessage = styled.span`
  color: ${COLOR_CONFIG.red};
  font-size: 1rem;
  font-weight: 600;
  margin-top: 6px;
`;
